export default {"src":"/_next/static/media/rockpool.ba9add0b.svg","height":32,"width":32};